import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { ROUTES } from "../../routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./new-home-design.css";
import ContactUS from "../../components/contact-us";
import { ResourceRoute } from "../../pages/resources/resource-routing";
// import { ToastComponent } from '../../components/common';
import ReactSEOMetaTags from "react-seo-meta-tags";
import { Helmet } from "react-helmet";
import * as contactAction from "../../action/contactAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Testimonials from "../../components/testimonials/testimonials";
class NewHomeDesign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      headerClassAdd: "",
      showContactUS: false,
      showToast: false,
      preHeaderClass: false,
      blogs: [],
    };
    this.onScrollHeader = this.onScrollHeader.bind(this);
  }
  async componentDidMount() {
    window.addEventListener("scroll", this.onScrollHeader);
    this.props.getBlogs()
    .then(blogList => {
      console.log("BlogList", blogList);
      this.setState({
        blogs: blogList.data
      })
    })
    // setTimeout(() => {
    //   this.setState({ preHeaderClass : true})
    // }, 2000)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScrollHeader);
  }
  onScrollHeader() {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    const scrolled = winScroll / height;

    if (scrolled === 0) {
      this.setState({
        headerClassAdd: "",
      });
    } else {
      this.setState({
        headerClassAdd: "scrollHeader",
      });
    }
  }
  sendToast() {
    this.setState({ showContactUS: true });
  }
  render() {
    var settings = {
      // className: "center",
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      centerMode: true,
      // speed:8000,
      // autoplaySpeed: 12000,
      speed: 2000,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1098,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    };
    var awardSettings = {
      // className: "center",
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      centerMode: true,
      // speed:8000,
      // autoplaySpeed: 3000,
      speed: 2000,
      autoplaySpeed: 7000,
      pauseOnHover: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1098,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
          },
        },
      ],
    };

    const blogSettings = {
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      centerMode: true,
      speed: 2000,
      autoplaySpeed: 12000,
      pauseOnHover: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 0,
      adaptiveHeight: true,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    };
    
    const metaTitle =
      "Ionixx Technologies: Custom Software & Blockchain Development Company | UI UX & Product Design Services";
    const metaDescription =
      "Ionixx Technologies, a custom software & IT solutions provider for Fintech, Healthtech, Design, and Web3 industries using provide blockchain, cloud, & AI tech.";
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, shrink-to-fit=no, user-scalable=no, maximum-scale=1"
          />
          <title>
            Ionixx Technologies: Custom Software & Blockchain Development
            Company | UI UX & Product Design Services
          </title>
          <meta name="description" content={metaDescription} />
          <link rel="canonical" href="https://www.ionixxtech.com/" />
          <meta property="og:title" content={metaTitle} />
          <meta property="og:type" content={`website`} />
          <meta property="og:url" content={"https://www.ionixxtech.com/"} />
          <meta property="og:description" content={metaDescription} />
        </Helmet>
        {/* <ReactSEOMetaTags
                render={(el) => <Helmet>{el}</Helmet>}
                website={{ 
                    name: "Ionixx Technologies", 
                    title:"Ionixx Technologies: Custom Software & Blockchain Development Company | UI UX & Product Design Services", 
                    description: "Ionixx Technologies, a top custom software development company, offers UI and UX design, Blockchain development, Fintech solution, healthcare care solution,Online marketplace solutions, web application, and mobile application development services. Talk to us on your blockchain development or custom software development needs. Get free consultation now.",
                    type:"website",
                    image:'/assets/img/ionixx-logo.png',
                    url:"https://www.ionixxtech.com/"
                }}
                twitter={{ 
                    twitter: "https://www.ionixxtech.com/" }}
                /> */}
        <div className="new-design-home">
          <div className="section-1 design-cont">
            {/* <video autoPlay="autoplay" loop="loop" muted className="hero-bg">
              <source src="assets/img/home.mp4" type="video/mp4" />
            </video> */}
            <div className="custom-container">
            {/* {this.state.preHeaderClass ? "custom-section preHeaderAdded" : "custom-section"} */}
              <div className="custom-section">
                <div className="main-head-div">
                  <h1 className="main-head-1">
                    <span className="title-span">Your Go-to Technology Partner!</span>
                  </h1>
                </div>
                <div>
                  <p className="para-sub-title-span">
                    With deep domain expertise in FinTech and HealthTech, we are the perfect partner to understand how to align technology with your business needs. Our FinTech solutions encompass comprehensive brokerage and  Securities Trading Lifecycle Solutions, including pre-trade, core trade, and post-trade systems.
                  </p>
                  {/* <p className="short-div">Collaborate with us to experience building stellar products.</p> */}
                </div>
                  {/* <span onClick={this.sendToast.bind(this)} className="btn btn-primary connect-btn">Talk to us</span> */}
                  <div className="link-container">
                  <Link to={ROUTES.FINTECH} className="btn btn-primary connect-btn">Explore More</Link>
                  <Link to={ROUTES.CONTACTUS} className="btn btn-primary connect-btn">Talk to Us</Link>
                  </div>
              </div>
            </div>
          </div>
      <div className="section-5 company-info blue-bg">
      <div className="custom-container">
        <div>
        <div className="main-head-div custom-main-head-div">
                  <h2 className="main-head-1">
                    <span className="primary-span">Ionixx Empowers Your Business Beyond Technology</span>
                  </h2>
                </div>
          <div className="custom-section">
          <div>
                  <p className="para-sub2-title-span">
                  With a track record of surpassing industry giants, we handle end-to-end custom tech builds,integrations, and onboarding. Our Design Studio excels in creating intuitive UI/UX, ensuring your applications are user-friendly and visually appealing. Combined with robust backend  integrations, our expert team ensures your technology operates seamlessly and efficiently.</p>             
                   </div>
                   </div>
          <div className="read-more-link-container">
          <div class="testi-detailed-review">
             <a href={ROUTES.BROKERAGE}>FinTech</a>
                </div>
                <div class="testi-detailed-review">
             <a href={ROUTES.HEALTHCARE}>HealthTech</a>
                </div>
                <div class="testi-detailed-review">
             <a href={ROUTES.BlOCKCHAIN_NEW}>Web3</a>
                </div>
                <div class="testi-detailed-review">
             <a href={ROUTES.DESIGN}>Design Studio</a>
            </div>
            </div>
          </div>
        </div>
      </div>

          {/* <div className="section-3 beige-bg">
            <div className="custom-container">
              <div className="custom-section">
                <div className="main-head-div custom-main-head-div">
                  <h2 className="main-head-1">
                    <span className="primary-span">User experience makes</span>
                    <span className="secondary-span">all the difference</span>
                  </h2>
                </div>
                <div className="main-para-div">
                  <p className="para-short-span">
                    Because good UX creates strong brand & loyal customer
                  </p>
                  <p className="short-div">Collaborate with us to experience building stellar products.</p>
                </div>
                <div className="row">
                  <div className="content-section col-xl-12 col-lg-12 col-md-12">
                    <div className="left-section col-xl-6 col-lg-6 col-md-12 col-sm-12">
                      <div className="experience-list">
                        <div className="service-img ylow-bx">
                          <b>1</b>
                        </div>
                        <div className="experience-detail">
                          <strong>User journey</strong>
                          <span>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt
                          </span>
                        </div>
                      </div>
                      <div className="experience-list">
                        <div className="service-img ylow-bx">
                          <b>2</b>
                        </div>
                        <div className="experience-detail">
                          <strong>Rapid Prototyping</strong>
                          <span>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt
                          </span>
                        </div>
                      </div>
                      <div className="experience-list">
                        <div className="service-img ylow-bx">
                          <b>3</b>
                        </div>
                        <div className="experience-detail">
                          <strong>Visual & Interactive</strong>
                          <span>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt
                          </span>
                        </div>
                      </div>
                      <div className="experience-list">
                        <div className="experience-detail">
                          <Link to={"#"}>Learn More</Link>
                        </div>
                      </div>
                    </div>
                    <div className="right-section col-xl-6 col-lg-6 col-md-12 col-sm-12">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="424"
                        height="575"
                        viewBox="0 0 424 575"
                        fill="none"
                      >
                        <rect
                          x="3.53711"
                          y="3.53735"
                          width="127.895"
                          height="205.233"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="0.5"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="205.516"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="0.5"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="205.516"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2715"
                          y="11.2705"
                          width="112.428"
                          height="117.584"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2715"
                          y="137.588"
                          width="90.2579"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="150.478"
                          width="102.116"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="176.258"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="10.3713"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint0_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="128.065"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint1_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="10.3713"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint2_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.51"
                          y="128.065"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint3_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="100.729"
                          y="136.418"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint4_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="136.418"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint5_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="149.326"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint6_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="112.879"
                          y="149.326"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint7_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="100.729"
                          y="144.011"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint8_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="144.011"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint9_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="156.919"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint10_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="112.879"
                          y="156.919"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint11_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="175.143"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint12_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="200.959"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint13_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.51"
                          y="200.959"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint14_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="175.143"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint15_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="292.263"
                          y="318.041"
                          width="127.895"
                          height="205.233"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="289.04"
                          y="314.856"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="289.04"
                          y="520.631"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="417.364"
                          y="314.856"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="417.364"
                          y="520.631"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="325.775"
                          width="112.428"
                          height="117.584"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="324.728"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint16_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="324.728"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint17_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="442.421"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint18_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="442.421"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint19_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="452.093"
                          width="90.2579"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="464.982"
                          width="102.116"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="490.762"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="451.533"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint20_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="390.029"
                          y="451.533"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint21_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="458.367"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint22_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="464.441"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint23_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="401.418"
                          y="464.441"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint24_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="471.276"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint25_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="490.258"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint26_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="490.258"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint27_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="515.315"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint28_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="515.315"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint29_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="401.418"
                          y="471.276"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint30_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="390.029"
                          y="458.367"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint31_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="3.53711"
                          y="225.237"
                          width="127.895"
                          height="205.233"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="222.221"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="427.995"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="222.221"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="427.995"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="232.972"
                          width="112.428"
                          height="117.584"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="232.092"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint32_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="349.786"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint33_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="122.75"
                          y="232.092"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint34_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="122.75"
                          y="349.786"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint35_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="359.289"
                          width="90.2579"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2715"
                          y="372.178"
                          width="102.116"
                          height="6.73372"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="397.958"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="358.138"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint36_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="371.047"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint37_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="112.879"
                          y="371.047"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint38_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="100.729"
                          y="358.138"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint39_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="365.731"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint40_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="378.64"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint41_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="396.863"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint42_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="396.863"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint43_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="422.681"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint44_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.51"
                          y="422.681"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint45_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="112.879"
                          y="378.64"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint46_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="100.729"
                          y="365.731"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint47_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="147.9"
                          y="3.53735"
                          width="127.895"
                          height="127.895"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.771"
                          y="0.5"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.771"
                          y="128.824"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.095"
                          y="0.5"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.095"
                          y="128.824"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="11.2705"
                          width="112.428"
                          height="55.714"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="10.3713"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint48_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="66.5605"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint49_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="10.3713"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint50_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="66.5605"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint51_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="75.7188"
                          width="90.2579"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="84.9988"
                          width="71.1814"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="98.9199"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="74.9128"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint52_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="245.76"
                          y="74.9128"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint53_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="79.4688"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint54_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="84.0247"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint55_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="226.018"
                          y="84.0247"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint56_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="88.5801"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint57_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="98.4521"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint58_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="98.4521"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint59_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="122.75"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint60_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="122.75"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint61_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="226.018"
                          y="88.5801"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint62_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="245.76"
                          y="79.4688"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint63_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="292.262"
                          y="173.68"
                          width="127.895"
                          height="127.895"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="289.04"
                          y="170.587"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="289.04"
                          y="298.911"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="417.364"
                          y="170.587"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="417.364"
                          y="298.911"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="181.413"
                          width="112.428"
                          height="55.714"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="245.86"
                          width="90.2579"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="255.141"
                          width="36.1219"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="299.995"
                          y="269.062"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="180.458"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint64_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="180.458"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint65_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="236.647"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint66_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="245"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint67_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="390.029"
                          y="245"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint68_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="249.556"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint69_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.911"
                          y="254.112"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint70_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="336.117"
                          y="254.112"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint71_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="258.667"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint72_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="268.539"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint73_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="268.539"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint74_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="298.91"
                          y="293.596"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint75_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="293.596"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint76_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="336.117"
                          y="258.667"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint77_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="390.029"
                          y="249.556"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint78_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="412.049"
                          y="236.647"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint79_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="291.763"
                          y="3.03735"
                          width="128.895"
                          height="154.674"
                          fill="#F9DF9F"
                        />
                        <rect
                          x="299.496"
                          y="10.7708"
                          width="113.428"
                          height="72.1814"
                          fill="white"
                          fill-opacity="0.6"
                        />
                        <rect
                          x="299.496"
                          y="88.1077"
                          width="91.2579"
                          height="5.15582"
                          fill="white"
                        />
                        <rect
                          x="299.496"
                          y="97.3889"
                          width="72.1814"
                          height="5.15582"
                          fill="white"
                        />
                        <rect
                          x="299.495"
                          y="106.67"
                          width="102.601"
                          height="5.15582"
                          fill="white"
                        />
                        <rect
                          x="299.495"
                          y="124.199"
                          width="113.428"
                          height="25.7791"
                          fill="white"
                        />
                        <rect
                          x="147.9"
                          y="292.263"
                          width="127.895"
                          height="153.674"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.77"
                          y="289.04"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.77"
                          y="443.182"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.094"
                          y="289.041"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.094"
                          y="443.182"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="299.997"
                          width="112.428"
                          height="71.1814"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="298.911"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint80_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.778"
                          y="298.911"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint81_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="371.046"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint82_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="371.046"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint83_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="377.334"
                          width="90.2579"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="386.615"
                          width="71.1814"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.634"
                          y="395.896"
                          width="101.601"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="413.425"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="376.361"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint84_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="245.759"
                          y="376.361"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint85_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="380.917"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint86_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="385.474"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint87_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="395.344"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint88_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="257.148"
                          y="395.344"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint89_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="399.141"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint90_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="412.809"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint91_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.778"
                          y="412.809"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint92_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="437.866"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint93_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="437.866"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint94_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="257.148"
                          y="399.141"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint95_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="226.016"
                          y="385.474"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint96_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.641"
                          y="390.029"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint97_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="226.017"
                          y="390.029"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint98_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="245.758"
                          y="380.917"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint99_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="147.899"
                          y="147.9"
                          width="127.895"
                          height="127.895"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.771"
                          y="144.77"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="144.771"
                          y="273.094"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.095"
                          y="144.769"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="273.095"
                          y="273.094"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="155.634"
                          width="112.428"
                          height="55.714"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="154.641"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint100_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="154.641"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint101_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="210.83"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint102_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="210.83"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint103_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="220.081"
                          width="103.663"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="229.361"
                          width="58.8075"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="155.633"
                          y="243.282"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="219.183"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint104_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="228.294"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint105_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="213.868"
                          y="228.294"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint106_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="258.668"
                          y="219.183"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint107_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="223.738"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint108_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="232.851"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint109_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="242.721"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint110_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="242.721"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint111_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="154.642"
                          y="267.778"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint112_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="267.779"
                          y="267.778"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint113_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="213.868"
                          y="232.851"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint114_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="258.668"
                          y="223.738"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint115_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="3.53711"
                          y="446.219"
                          width="127.895"
                          height="127.895"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="443.182"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="0.5"
                          y="568.469"
                          width="5.83384"
                          height="5.83384"
                          fill="#FFCC4A"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="443.182"
                          width="5.83384"
                          height="5.83384"
                          fill="#F9DF9F"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="128.824"
                          y="568.469"
                          width="5.83384"
                          height="5.83384"
                          fill="#FFCC4A"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="453.953"
                          width="112.428"
                          height="55.714"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="518.4"
                          width="103.663"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="527.681"
                          width="58.8075"
                          height="4.15582"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="11.2705"
                          y="541.602"
                          width="112.428"
                          height="24.7791"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="453.053"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint116_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="453.053"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint117_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="509.242"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint118_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="517.595"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint119_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="114.397"
                          y="517.595"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint120_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="522.151"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint121_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="526.706"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint122_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="69.5977"
                          y="526.706"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint123_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="531.263"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint124_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="541.134"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint125_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="10.3711"
                          y="561.635"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint126_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.51"
                          y="541.134"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint127_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="561.635"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint128_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="69.5977"
                          y="531.263"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint129_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="114.397"
                          y="522.151"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint130_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <rect
                          x="123.509"
                          y="509.242"
                          width="1.27795"
                          height="1.27795"
                          fill="url(#paint131_linear_25_1402)"
                          stroke="#C7D0D3"
                        />
                        <path
                          d="M120.59 39.9015C120.59 38.0456 116.865 36.7948 116.311 35.1003C115.756 33.3653 118.054 30.0972 116.984 28.6447C115.915 27.1519 112.191 28.4027 110.725 27.3133C109.298 26.2643 109.259 22.2296 107.555 21.6647C105.891 21.0999 103.593 24.3276 101.731 24.3276C99.9088 24.3276 97.5713 21.0999 95.9074 21.6647C94.2038 22.2296 94.1641 26.2239 92.7379 27.3133C91.272 28.4027 87.5479 27.1519 86.4782 28.6447C85.4481 30.0972 87.7064 33.3653 87.1517 35.1003C86.6763 36.7948 82.9521 38.0456 82.9521 39.9015C82.9521 41.7575 86.6763 43.0082 87.2309 44.7028C87.7856 46.4377 85.4877 49.7058 86.5574 51.1583C87.6271 52.6512 91.3512 51.4004 92.8171 52.4898C94.2434 53.5388 94.283 57.5735 95.9866 58.1383C97.6506 58.7032 99.9484 55.4754 101.81 55.4754C103.633 55.4754 105.97 58.7032 107.634 58.1383C109.338 57.5735 109.378 53.5791 110.804 52.4898C112.27 51.4004 115.994 52.6512 117.064 51.1583C118.094 49.7058 115.835 46.4377 116.39 44.7028C116.865 43.0082 120.59 41.7575 120.59 39.9015ZM96.8978 32.2356C98.3637 32.2356 99.5522 33.446 99.5522 34.9389C99.5522 36.4317 98.3637 37.6421 96.8978 37.6421C95.4319 37.6421 94.2434 36.4317 94.2434 34.9389C94.2434 33.446 95.4319 32.2356 96.8978 32.2356ZM106.644 47.5674C105.178 47.5674 103.99 46.357 103.99 44.8642C103.99 43.3714 105.178 42.161 106.644 42.161C108.11 42.161 109.298 43.3714 109.298 44.8642C109.298 46.357 108.11 47.5674 106.644 47.5674ZM108.863 35.2213L97.1751 47.1236C96.8186 47.4868 96.3828 47.6481 95.9074 47.6481C95.4716 47.6481 94.9961 47.4868 94.6396 47.1236C93.9661 46.4377 93.9661 45.2677 94.6396 44.5818L106.327 32.6794C107.001 31.9935 108.149 31.9935 108.823 32.6794C109.536 33.4057 109.536 34.5354 108.863 35.2213Z"
                          fill="#C7D0D3"
                        />
                        <path
                          d="M262.375 327.596C262.375 325.74 258.651 324.489 258.096 322.795C257.541 321.06 259.839 317.792 258.769 316.339C257.7 314.846 253.976 316.097 252.51 315.008C251.084 313.959 251.044 309.924 249.34 309.359C247.676 308.794 245.378 312.022 243.516 312.022C241.694 312.022 239.356 308.794 237.693 309.359C235.989 309.924 235.949 313.919 234.523 315.008C233.057 316.097 229.333 314.846 228.263 316.339C227.233 317.792 229.492 321.06 228.937 322.795C228.461 324.489 224.737 325.74 224.737 327.596C224.737 329.452 228.461 330.703 229.016 332.397C229.571 334.132 227.273 337.4 228.343 338.853C229.412 340.346 233.136 339.095 234.602 340.184C236.029 341.233 236.068 345.268 237.772 345.833C239.436 346.398 241.734 343.17 243.596 343.17C245.418 343.17 247.756 346.398 249.42 345.833C251.123 345.268 251.163 341.274 252.589 340.184C254.055 339.095 257.779 340.346 258.849 338.853C259.879 337.4 257.621 334.132 258.175 332.397C258.651 330.703 262.375 329.452 262.375 327.596ZM238.683 319.93C240.149 319.93 241.337 321.141 241.337 322.633C241.337 324.126 240.149 325.337 238.683 325.337C237.217 325.337 236.029 324.126 236.029 322.633C236.029 321.141 237.217 319.93 238.683 319.93ZM248.429 335.262C246.963 335.262 245.775 334.052 245.775 332.559C245.775 331.066 246.963 329.856 248.429 329.856C249.895 329.856 251.084 331.066 251.084 332.559C251.084 334.052 249.895 335.262 248.429 335.262ZM250.648 322.916L238.96 334.818C238.604 335.181 238.168 335.343 237.693 335.343C237.257 335.343 236.781 335.181 236.425 334.818C235.751 334.132 235.751 332.962 236.425 332.276L248.112 320.374C248.786 319.688 249.935 319.688 250.608 320.374C251.321 321.1 251.321 322.23 250.648 322.916Z"
                          fill="#C7D0D3"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_25_1402"
                            x1="9.87109"
                            y1="10.8482"
                            x2="11.0101"
                            y2="10.8482"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_25_1402"
                            x1="9.87109"
                            y1="128.542"
                            x2="11.0101"
                            y2="128.542"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear_25_1402"
                            x1="123.009"
                            y1="10.8482"
                            x2="124.148"
                            y2="10.8482"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint3_linear_25_1402"
                            x1="123.01"
                            y1="128.542"
                            x2="124.149"
                            y2="128.542"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint4_linear_25_1402"
                            x1="100.229"
                            y1="136.895"
                            x2="101.368"
                            y2="136.895"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint5_linear_25_1402"
                            x1="9.87109"
                            y1="136.895"
                            x2="11.0101"
                            y2="136.895"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint6_linear_25_1402"
                            x1="9.87109"
                            y1="149.803"
                            x2="11.0101"
                            y2="149.803"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint7_linear_25_1402"
                            x1="112.379"
                            y1="149.803"
                            x2="113.518"
                            y2="149.803"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint8_linear_25_1402"
                            x1="100.229"
                            y1="144.488"
                            x2="101.368"
                            y2="144.488"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint9_linear_25_1402"
                            x1="9.87109"
                            y1="144.488"
                            x2="11.0101"
                            y2="144.488"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint10_linear_25_1402"
                            x1="9.87109"
                            y1="157.396"
                            x2="11.0101"
                            y2="157.396"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint11_linear_25_1402"
                            x1="112.379"
                            y1="157.396"
                            x2="113.518"
                            y2="157.396"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint12_linear_25_1402"
                            x1="9.87109"
                            y1="175.62"
                            x2="11.0101"
                            y2="175.62"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint13_linear_25_1402"
                            x1="9.87109"
                            y1="201.436"
                            x2="11.0101"
                            y2="201.436"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint14_linear_25_1402"
                            x1="123.01"
                            y1="201.436"
                            x2="124.149"
                            y2="201.436"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint15_linear_25_1402"
                            x1="123.009"
                            y1="175.62"
                            x2="124.148"
                            y2="175.62"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint16_linear_25_1402"
                            x1="298.411"
                            y1="325.204"
                            x2="299.55"
                            y2="325.204"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint17_linear_25_1402"
                            x1="411.549"
                            y1="325.204"
                            x2="412.688"
                            y2="325.204"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint18_linear_25_1402"
                            x1="298.41"
                            y1="442.898"
                            x2="299.549"
                            y2="442.898"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint19_linear_25_1402"
                            x1="411.549"
                            y1="442.898"
                            x2="412.688"
                            y2="442.898"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint20_linear_25_1402"
                            x1="298.411"
                            y1="452.01"
                            x2="299.55"
                            y2="452.01"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint21_linear_25_1402"
                            x1="389.529"
                            y1="452.01"
                            x2="390.668"
                            y2="452.01"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint22_linear_25_1402"
                            x1="298.411"
                            y1="458.844"
                            x2="299.55"
                            y2="458.844"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint23_linear_25_1402"
                            x1="298.411"
                            y1="464.918"
                            x2="299.55"
                            y2="464.918"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint24_linear_25_1402"
                            x1="400.918"
                            y1="464.918"
                            x2="402.057"
                            y2="464.918"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint25_linear_25_1402"
                            x1="298.411"
                            y1="471.752"
                            x2="299.55"
                            y2="471.752"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint26_linear_25_1402"
                            x1="298.41"
                            y1="490.735"
                            x2="299.549"
                            y2="490.735"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint27_linear_25_1402"
                            x1="411.549"
                            y1="490.735"
                            x2="412.688"
                            y2="490.735"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint28_linear_25_1402"
                            x1="298.411"
                            y1="515.792"
                            x2="299.55"
                            y2="515.792"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint29_linear_25_1402"
                            x1="411.549"
                            y1="515.792"
                            x2="412.688"
                            y2="515.792"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint30_linear_25_1402"
                            x1="400.918"
                            y1="471.752"
                            x2="402.057"
                            y2="471.752"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint31_linear_25_1402"
                            x1="389.529"
                            y1="458.844"
                            x2="390.668"
                            y2="458.844"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint32_linear_25_1402"
                            x1="9.87109"
                            y1="232.569"
                            x2="11.0101"
                            y2="232.569"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint33_linear_25_1402"
                            x1="9.87109"
                            y1="350.263"
                            x2="11.0101"
                            y2="350.263"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint34_linear_25_1402"
                            x1="122.25"
                            y1="232.569"
                            x2="123.389"
                            y2="232.569"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint35_linear_25_1402"
                            x1="122.25"
                            y1="350.263"
                            x2="123.389"
                            y2="350.263"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint36_linear_25_1402"
                            x1="9.87109"
                            y1="358.615"
                            x2="11.0101"
                            y2="358.615"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint37_linear_25_1402"
                            x1="9.87109"
                            y1="371.523"
                            x2="11.0101"
                            y2="371.523"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint38_linear_25_1402"
                            x1="112.379"
                            y1="371.523"
                            x2="113.518"
                            y2="371.523"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint39_linear_25_1402"
                            x1="100.229"
                            y1="358.615"
                            x2="101.368"
                            y2="358.615"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint40_linear_25_1402"
                            x1="9.87109"
                            y1="366.208"
                            x2="11.0101"
                            y2="366.208"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint41_linear_25_1402"
                            x1="9.87109"
                            y1="379.116"
                            x2="11.0101"
                            y2="379.116"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint42_linear_25_1402"
                            x1="9.87109"
                            y1="397.34"
                            x2="11.0101"
                            y2="397.34"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint43_linear_25_1402"
                            x1="123.009"
                            y1="397.34"
                            x2="124.148"
                            y2="397.34"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint44_linear_25_1402"
                            x1="9.87109"
                            y1="423.157"
                            x2="11.0101"
                            y2="423.157"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint45_linear_25_1402"
                            x1="123.01"
                            y1="423.157"
                            x2="124.149"
                            y2="423.157"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint46_linear_25_1402"
                            x1="112.379"
                            y1="379.116"
                            x2="113.518"
                            y2="379.116"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint47_linear_25_1402"
                            x1="100.229"
                            y1="366.208"
                            x2="101.368"
                            y2="366.208"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint48_linear_25_1402"
                            x1="154.142"
                            y1="10.8482"
                            x2="155.281"
                            y2="10.8482"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint49_linear_25_1402"
                            x1="154.142"
                            y1="67.0374"
                            x2="155.281"
                            y2="67.0374"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint50_linear_25_1402"
                            x1="267.279"
                            y1="10.8482"
                            x2="268.418"
                            y2="10.8482"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint51_linear_25_1402"
                            x1="267.279"
                            y1="67.0374"
                            x2="268.418"
                            y2="67.0374"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint52_linear_25_1402"
                            x1="154.142"
                            y1="75.3897"
                            x2="155.281"
                            y2="75.3897"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint53_linear_25_1402"
                            x1="245.26"
                            y1="75.3897"
                            x2="246.399"
                            y2="75.3897"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint54_linear_25_1402"
                            x1="154.142"
                            y1="79.9456"
                            x2="155.281"
                            y2="79.9456"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint55_linear_25_1402"
                            x1="154.142"
                            y1="84.5015"
                            x2="155.281"
                            y2="84.5015"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint56_linear_25_1402"
                            x1="225.518"
                            y1="84.5015"
                            x2="226.657"
                            y2="84.5015"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint57_linear_25_1402"
                            x1="154.142"
                            y1="89.0569"
                            x2="155.281"
                            y2="89.0569"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint58_linear_25_1402"
                            x1="154.142"
                            y1="98.929"
                            x2="155.281"
                            y2="98.929"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint59_linear_25_1402"
                            x1="267.279"
                            y1="98.929"
                            x2="268.418"
                            y2="98.929"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint60_linear_25_1402"
                            x1="154.142"
                            y1="123.227"
                            x2="155.281"
                            y2="123.227"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint61_linear_25_1402"
                            x1="267.279"
                            y1="123.227"
                            x2="268.418"
                            y2="123.227"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint62_linear_25_1402"
                            x1="225.518"
                            y1="89.0569"
                            x2="226.657"
                            y2="89.0569"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint63_linear_25_1402"
                            x1="245.26"
                            y1="79.9456"
                            x2="246.399"
                            y2="79.9456"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint64_linear_25_1402"
                            x1="298.41"
                            y1="180.935"
                            x2="299.549"
                            y2="180.935"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint65_linear_25_1402"
                            x1="411.549"
                            y1="180.935"
                            x2="412.688"
                            y2="180.935"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint66_linear_25_1402"
                            x1="298.41"
                            y1="237.124"
                            x2="299.549"
                            y2="237.124"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint67_linear_25_1402"
                            x1="298.41"
                            y1="245.477"
                            x2="299.549"
                            y2="245.477"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint68_linear_25_1402"
                            x1="389.529"
                            y1="245.477"
                            x2="390.668"
                            y2="245.477"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint69_linear_25_1402"
                            x1="298.411"
                            y1="250.032"
                            x2="299.55"
                            y2="250.032"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint70_linear_25_1402"
                            x1="298.411"
                            y1="254.588"
                            x2="299.55"
                            y2="254.588"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint71_linear_25_1402"
                            x1="335.617"
                            y1="254.588"
                            x2="336.756"
                            y2="254.588"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint72_linear_25_1402"
                            x1="298.41"
                            y1="259.144"
                            x2="299.549"
                            y2="259.144"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint73_linear_25_1402"
                            x1="298.41"
                            y1="269.016"
                            x2="299.549"
                            y2="269.016"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint74_linear_25_1402"
                            x1="411.549"
                            y1="269.016"
                            x2="412.688"
                            y2="269.016"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint75_linear_25_1402"
                            x1="298.41"
                            y1="294.073"
                            x2="299.549"
                            y2="294.073"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint76_linear_25_1402"
                            x1="411.549"
                            y1="294.073"
                            x2="412.688"
                            y2="294.073"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint77_linear_25_1402"
                            x1="335.617"
                            y1="259.144"
                            x2="336.756"
                            y2="259.144"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint78_linear_25_1402"
                            x1="389.529"
                            y1="250.032"
                            x2="390.668"
                            y2="250.032"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint79_linear_25_1402"
                            x1="411.549"
                            y1="237.124"
                            x2="412.688"
                            y2="237.124"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint80_linear_25_1402"
                            x1="154.141"
                            y1="299.388"
                            x2="155.28"
                            y2="299.388"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint81_linear_25_1402"
                            x1="267.278"
                            y1="299.388"
                            x2="268.417"
                            y2="299.388"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint82_linear_25_1402"
                            x1="154.141"
                            y1="371.523"
                            x2="155.28"
                            y2="371.523"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint83_linear_25_1402"
                            x1="267.279"
                            y1="371.523"
                            x2="268.418"
                            y2="371.523"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint84_linear_25_1402"
                            x1="154.141"
                            y1="376.838"
                            x2="155.28"
                            y2="376.838"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint85_linear_25_1402"
                            x1="245.259"
                            y1="376.838"
                            x2="246.398"
                            y2="376.838"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint86_linear_25_1402"
                            x1="154.141"
                            y1="381.394"
                            x2="155.28"
                            y2="381.394"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint87_linear_25_1402"
                            x1="154.141"
                            y1="385.951"
                            x2="155.28"
                            y2="385.951"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint88_linear_25_1402"
                            x1="154.141"
                            y1="395.821"
                            x2="155.28"
                            y2="395.821"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint89_linear_25_1402"
                            x1="256.648"
                            y1="395.821"
                            x2="257.787"
                            y2="395.821"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint90_linear_25_1402"
                            x1="154.141"
                            y1="399.618"
                            x2="155.28"
                            y2="399.618"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint91_linear_25_1402"
                            x1="154.141"
                            y1="413.285"
                            x2="155.28"
                            y2="413.285"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint92_linear_25_1402"
                            x1="267.278"
                            y1="413.285"
                            x2="268.417"
                            y2="413.285"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint93_linear_25_1402"
                            x1="154.141"
                            y1="438.343"
                            x2="155.28"
                            y2="438.343"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint94_linear_25_1402"
                            x1="267.279"
                            y1="438.343"
                            x2="268.418"
                            y2="438.343"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint95_linear_25_1402"
                            x1="256.648"
                            y1="399.618"
                            x2="257.787"
                            y2="399.618"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint96_linear_25_1402"
                            x1="225.516"
                            y1="385.951"
                            x2="226.655"
                            y2="385.951"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint97_linear_25_1402"
                            x1="154.141"
                            y1="390.506"
                            x2="155.28"
                            y2="390.506"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint98_linear_25_1402"
                            x1="225.517"
                            y1="390.506"
                            x2="226.656"
                            y2="390.506"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint99_linear_25_1402"
                            x1="245.258"
                            y1="381.394"
                            x2="246.397"
                            y2="381.394"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint100_linear_25_1402"
                            x1="154.142"
                            y1="155.117"
                            x2="155.281"
                            y2="155.117"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint101_linear_25_1402"
                            x1="267.279"
                            y1="155.117"
                            x2="268.418"
                            y2="155.117"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint102_linear_25_1402"
                            x1="154.142"
                            y1="211.307"
                            x2="155.281"
                            y2="211.307"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint103_linear_25_1402"
                            x1="267.279"
                            y1="211.307"
                            x2="268.418"
                            y2="211.307"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint104_linear_25_1402"
                            x1="154.142"
                            y1="219.659"
                            x2="155.281"
                            y2="219.659"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint105_linear_25_1402"
                            x1="154.142"
                            y1="228.771"
                            x2="155.281"
                            y2="228.771"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint106_linear_25_1402"
                            x1="213.368"
                            y1="228.771"
                            x2="214.507"
                            y2="228.771"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint107_linear_25_1402"
                            x1="258.168"
                            y1="219.659"
                            x2="259.307"
                            y2="219.659"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint108_linear_25_1402"
                            x1="154.142"
                            y1="224.215"
                            x2="155.281"
                            y2="224.215"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint109_linear_25_1402"
                            x1="154.142"
                            y1="233.327"
                            x2="155.281"
                            y2="233.327"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint110_linear_25_1402"
                            x1="154.142"
                            y1="243.198"
                            x2="155.281"
                            y2="243.198"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint111_linear_25_1402"
                            x1="267.279"
                            y1="243.198"
                            x2="268.418"
                            y2="243.198"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint112_linear_25_1402"
                            x1="154.142"
                            y1="268.255"
                            x2="155.281"
                            y2="268.255"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint113_linear_25_1402"
                            x1="267.279"
                            y1="268.255"
                            x2="268.418"
                            y2="268.255"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint114_linear_25_1402"
                            x1="213.368"
                            y1="233.327"
                            x2="214.507"
                            y2="233.327"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint115_linear_25_1402"
                            x1="258.168"
                            y1="224.215"
                            x2="259.307"
                            y2="224.215"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint116_linear_25_1402"
                            x1="9.87109"
                            y1="453.53"
                            x2="11.0101"
                            y2="453.53"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint117_linear_25_1402"
                            x1="123.009"
                            y1="453.53"
                            x2="124.148"
                            y2="453.53"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint118_linear_25_1402"
                            x1="9.87109"
                            y1="509.719"
                            x2="11.0101"
                            y2="509.719"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint119_linear_25_1402"
                            x1="9.87109"
                            y1="518.072"
                            x2="11.0101"
                            y2="518.072"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint120_linear_25_1402"
                            x1="113.897"
                            y1="518.072"
                            x2="115.036"
                            y2="518.072"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint121_linear_25_1402"
                            x1="9.87109"
                            y1="522.627"
                            x2="11.0101"
                            y2="522.627"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint122_linear_25_1402"
                            x1="9.87109"
                            y1="527.183"
                            x2="11.0101"
                            y2="527.183"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint123_linear_25_1402"
                            x1="69.0977"
                            y1="527.183"
                            x2="70.2366"
                            y2="527.183"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint124_linear_25_1402"
                            x1="9.87109"
                            y1="531.74"
                            x2="11.0101"
                            y2="531.74"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint125_linear_25_1402"
                            x1="9.87109"
                            y1="541.611"
                            x2="11.0101"
                            y2="541.611"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint126_linear_25_1402"
                            x1="9.87109"
                            y1="562.112"
                            x2="11.0101"
                            y2="562.112"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint127_linear_25_1402"
                            x1="123.01"
                            y1="541.611"
                            x2="124.149"
                            y2="541.611"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint128_linear_25_1402"
                            x1="123.009"
                            y1="562.112"
                            x2="124.148"
                            y2="562.112"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint129_linear_25_1402"
                            x1="69.0977"
                            y1="531.74"
                            x2="70.2366"
                            y2="531.74"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint130_linear_25_1402"
                            x1="113.897"
                            y1="522.627"
                            x2="115.036"
                            y2="522.627"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                          <linearGradient
                            id="paint131_linear_25_1402"
                            x1="123.009"
                            y1="509.719"
                            x2="124.148"
                            y2="509.719"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#FFFBF1" />
                            <stop offset="1" stop-color="#F9F9F9" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="section-4 beige-bg">
            <div className="custom-container">
              <div className="custom-section">
                <div className="main-head-div custom-main-head-div">
                  <h2 className="main-head-1">
                    <span className="secondary-span">A deep dive into</span>
                    <span className="primary-span">Our Methods</span>
                  </h2>
                </div>
                <div className="row">
                  <div className="content-section">
                    <div className="method-list col-xl-6 col-lg-6 col-md-12 col-sm-12">
                      <strong>Design Driven Approach</strong>
                      <p>
                        We are committed to helping you build meaningful and
                        desirable products through <b>our design process</b>.
                        Our team seeks to design key interactions that are
                        crucial for the success of your product through a
                        comprehensive product strategy, creating value, and
                        distinguished user experience.
                      </p>
                      <Link to={"/solution/ui-ux-design-services-company"}>Know More</Link>
                    </div>
                    <div className="method-list col-xl-6 col-lg-6 col-md-12 col-sm-12">
                      <strong>Test Driven Development</strong>
                      <p>
                        We are committed to deliver the high quality product
                        through <b>our development process</b> with test driven
                        development (TDD) approach. TDD helps us to deliver the
                        high quality product by bringing clarity to
                        requirements.
                      </p>
                      <Link to={"/solution/software-development-company"}>Know More</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div className="section-2 blue-bg company-info">
            <div className="custom-container">
              <div className="custom-section">
                <div className="main-head-div custom-main-head-div">
                  <h2 className="main-head-1">
                    <span className="secondary-span">What makes us</span>
                    <span className="primary-span">
                      Effective, Efficient & Elegant
                    </span>
                  </h2>
                </div>

                <div className="row c-cards-mg">
                  <div className="first-row col-xl-10 col-lg-10 col-md-12 col-sm-12">
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mb-2">
                    <div className="overall-sec-11">
                      <div className="sec-11">
                        <div
                          className="service-img ylow-bx"
                          title="Cutting edge technology stack"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="130"
                            height="130"
                            viewBox="0 0 130 130"
                            fill="none"
                          >
                            <path
                              d="M53 48.5L55 56C56.5 58.6667 63.6 62.5258 80 56.6289C96.4 50.732 100.5 44.0859 100.5 41.5L98.5 34C96.1667 37.3333 88.2 45 75 49C61.8 53 54.8333 50.3333 53 48.5Z"
                              fill="#FFCC4A"
                            />
                            <path
                              d="M34.5 45.5L30.5 52C30.8333 55.8333 35.1 65.6 49.5 74C63.9 82.4 70.5 80.5 72 78.5L75 71C74.8333 71.3333 73.8 72 71 72C47.4 66.8 36.8333 52.1667 34.5 45.5Z"
                              fill="#FFCC4A"
                            />
                            <path
                              d="M45.5 94.5V87.5C49.8333 89.5 60.8 93.6 70 94C79.2 94.4 89.5 89.8333 93.5 87.5V94.5C92.3333 96.6667 86 101.3 70 102.5C54 103.7 47 97.6667 45.5 94.5Z"
                              fill="#FFCC4A"
                            />
                            <path
                              d="M57.1672 78.6608C54.0622 79.4929 51.5052 80.533 49.6787 81.7811C48.2175 82.6132 47.4869 83.6533 47.4869 84.4854C47.4869 86.1496 49.6787 87.8138 53.3316 89.2699C57.5325 90.9341 63.3772 91.7662 69.7699 91.7662C76.1625 91.7662 82.0072 90.9341 86.2081 89.2699C89.861 87.8138 92.0528 86.1496 92.0528 84.4854C92.0528 83.2373 90.2263 81.7811 87.4866 80.325C84.199 78.8688 79.6328 77.8287 74.336 77.4127L73.9707 78.4528C72.5096 81.3651 68.4913 81.9892 63.3772 80.741C61.3681 80.325 59.359 79.7009 57.1672 78.6608ZM90.9569 49.3297L89.861 44.5452C88.0346 45.5853 86.0255 46.4174 83.8337 47.4575L84.9296 52.242C87.1213 51.2019 89.1305 50.3698 90.9569 49.3297ZM92.6007 42.673L93.6966 47.4575L94.2446 47.0414C97.3496 44.7532 99.176 42.465 98.8108 40.8008L98.0802 37.8885C97.1669 39.1366 95.7057 40.5928 94.0619 41.8409C93.514 42.0489 93.1487 42.465 92.6007 42.673ZM82.0072 53.4901L80.9113 48.4976C79.8155 48.9136 78.9022 49.3297 77.8063 49.5377C76.7105 49.9538 75.7972 50.1618 74.7013 50.3698L75.7972 55.3623C76.8931 54.9463 77.8063 54.7383 78.9022 54.3222C79.9981 54.1142 81.094 53.6981 82.0072 53.4901ZM54.9755 50.9939L55.706 53.9062C56.0713 55.5703 58.6284 56.4024 62.464 56.8185H63.0119L61.916 52.034C61.3681 52.034 60.8202 52.034 60.4549 52.034C58.2631 51.8259 56.6193 51.6179 54.9755 50.9939ZM66.2996 56.8185C68.3087 56.6105 70.5005 56.4024 72.6922 55.9864L71.5963 51.2019C69.4046 51.6179 67.2128 51.8259 65.2037 52.034L66.2996 56.8185ZM99.9066 31.6478L101.916 39.9687C102.646 43.089 100.272 46.8334 95.8884 50.1618C92.0528 53.0741 86.2081 55.9864 79.8155 57.8586C77.989 58.4827 76.1625 58.8987 74.336 59.3147C75.6146 60.9789 76.7105 62.6431 77.2584 64.0993C78.5369 66.8035 78.7196 69.0918 77.6237 70.964L76.1625 74.0843C81.094 74.5004 85.2949 75.5405 88.5825 76.9966C92.7834 78.8688 95.1578 81.5731 95.1578 84.4854V93.2224C95.1578 96.5507 92.2355 99.463 87.1213 101.335C82.7378 102.999 76.5278 104.04 69.7699 104.04C63.0119 104.04 56.8019 102.999 52.4184 101.335C47.3043 99.463 44.3819 96.5507 44.3819 93.2224V84.4854C44.3819 82.1972 45.6604 80.117 48.0349 78.6608C49.3134 77.8287 50.7746 76.9966 52.4184 76.3726C50.5919 75.5405 48.9481 74.5004 47.1216 73.2522C41.2769 69.5078 36.3454 65.1394 33.2404 60.9789C29.7701 56.6105 28.309 52.242 29.7701 49.3297L33.6057 41.8409C34.7016 39.5526 37.4413 38.7206 41.0943 38.9286C44.0166 39.1366 47.4869 40.3847 51.5052 42.0489C52.4184 40.1767 54.2449 38.0965 56.6193 36.4323C60.6375 33.312 66.2996 30.6077 72.8749 28.5275C79.4502 26.6553 85.6602 25.8232 90.2263 26.0312C95.5231 26.4472 99.176 28.3194 99.9066 31.6478ZM70.5005 59.9388C67.5781 60.3549 64.6557 60.5629 62.2813 60.3549C57.1672 59.9388 53.5143 58.0666 52.601 54.9463L50.7746 46.6254C50.5919 46.2094 50.5919 45.7933 50.5919 45.5853C46.939 43.9211 43.4687 42.881 40.9116 42.673C38.5372 42.465 36.8934 42.673 36.3454 43.7131C35.6149 45.1692 36.8934 47.8735 39.4504 51.2019C42.1902 54.9463 46.7563 58.8987 52.2357 62.6431H52.4184C58.0805 66.3875 63.5599 68.8838 67.7607 69.9239C71.5963 70.756 74.1534 70.5479 74.884 69.0918C75.2493 68.4677 75.0666 67.2196 74.5187 65.7634C73.7881 64.0993 72.3269 62.019 70.5005 59.9388ZM92.2355 38.7206C95.5231 36.4323 97.1669 34.1441 96.8016 32.4799C96.4363 31.0237 93.8793 29.9836 90.0437 29.7756C85.6602 29.3596 79.8155 30.1916 73.6055 32.0638C67.3955 33.936 62.0987 36.6403 58.4457 39.3446C55.1581 41.8409 53.5143 44.1291 53.8796 45.5853C54.2449 47.2495 56.8019 48.0816 60.6375 48.4976C65.021 48.7056 70.8657 48.0816 77.0757 46.0013C83.2857 44.1291 88.5825 41.6329 92.2355 38.7206ZM35.9802 59.1067L37.9893 54.9463C37.624 54.3222 37.2587 53.9062 37.076 53.4901C35.6149 51.8259 34.519 50.1618 33.971 48.4976L32.5099 51.2019C31.7793 52.658 33.0578 55.3623 35.6149 58.6907L35.9802 59.1067ZM40.3637 57.4425L38.3546 61.603C39.8157 63.2672 41.4596 64.7233 43.286 66.1795L45.4778 62.019C43.6513 60.3549 42.0075 58.8987 40.3637 57.4425ZM48.2175 63.8912L46.0257 68.2597C46.7563 68.8838 47.6696 69.5078 48.5828 70.1319H48.7654C49.6787 70.756 50.5919 71.38 51.5052 72.0041L53.6969 67.6356C52.7837 67.2196 52.0531 66.5955 51.3225 66.1795L50.9572 65.7634C49.8613 65.1394 48.9481 64.5153 48.2175 63.8912ZM56.4366 69.0918L54.2449 73.4603C56.4366 74.7084 58.4457 75.5405 60.2722 76.1645L62.464 72.0041C60.6375 71.172 58.6284 70.3399 56.4366 69.0918ZM65.569 73.0442L63.5599 77.2047H63.9252C67.7607 78.2448 70.5005 78.0367 71.231 76.5806L72.5096 73.8763C71.0484 74.0843 69.2219 73.8763 67.2128 73.4603C66.6649 73.2522 66.1169 73.0442 65.569 73.0442ZM53.8796 98.0069V93.2224C53.3316 93.0143 52.7837 92.8063 52.4184 92.5983C50.4093 91.9742 48.7654 91.1421 47.4869 90.102V93.2224C47.4869 94.8865 49.6787 96.5507 53.3316 97.7988L53.8796 98.0069ZM56.9846 94.0544V99.047C58.9937 99.463 61.1855 99.8791 63.3772 100.087V95.0946C61.1855 94.8865 58.9937 94.4705 56.9846 94.0544ZM66.6649 95.3026V100.295C67.5781 100.503 68.674 100.503 69.7699 100.503C70.8657 100.503 71.9616 100.503 72.8749 100.295V95.3026C71.9616 95.5106 70.8657 95.5106 69.7699 95.5106C68.674 95.5106 67.5781 95.5106 66.6649 95.3026ZM76.1625 95.0946V100.087C78.3543 99.8791 80.546 99.463 82.5552 99.047V94.0544C80.546 94.4705 78.3543 94.8865 76.1625 95.0946ZM85.6602 93.2224V98.0069L86.2081 97.7988C89.861 96.5507 92.0528 94.8865 92.0528 93.2224V90.102C90.7743 91.1421 89.1305 91.9742 87.1213 92.5983C86.756 92.8063 86.2081 93.0143 85.6602 93.2224Z"
                              fill="#2692AA"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="sec-22">
                        <div className="service-head">
                          <h3>AI-led automation</h3>
                        </div>
                        <div className="main-para-div">
                          <p>
                            We keep up with rapidly evolving, trending and
                            appropriate technologies.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 mb-2">
                    <div className="overall-sec-11">
                      <div className="sec-11">
                        <div
                          className="service-img ylow-bx"
                          title="Proprietary software architecture"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="82"
                            height="85"
                            viewBox="0 0 82 85"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M42.3384 0.730469C39.0913 0.730469 36.0447 1.61228 33.4188 3.13534C30.7929 1.61229 27.7462 0.730469 24.4991 0.730469C15.0225 0.730469 7.25546 8.1447 6.69036 17.4629H5.80963C5.55225 17.1617 5.16958 16.9707 4.74231 16.9707C3.83558 16.9707 2.66924 17.2075 1.69522 17.9613C0.66081 18.7619 0 20.0269 0 21.7323C0 22.5581 0.182967 23.2829 0.492676 23.9002V27.1752C0.191165 27.4326 0 27.8154 0 28.2429V75.2028C0 80.1641 4.02193 84.186 8.98323 84.186H76.4336C77.2086 84.186 77.8369 83.5577 77.8369 82.7827V62.8195C77.8369 62.802 77.8365 62.7846 77.8359 62.7673C77.8353 62.7497 77.8343 62.7322 77.833 62.7148H79.9583C80.7333 62.7148 81.3615 62.0865 81.3615 61.3115V44.6757C81.3615 43.9007 80.7333 43.2725 79.9583 43.2725H77.7334C77.7992 43.11 77.8354 42.9323 77.8354 42.7463V25.0666C77.8354 24.2915 77.2071 23.6633 76.4321 23.6633H71.9817V18.374C71.9817 17.599 71.3535 16.9707 70.5785 16.9707H60.0904C59.287 7.88497 51.6286 0.730469 42.3384 0.730469ZM63.567 62.7148H75.0342C75.0316 62.7493 75.0303 62.7843 75.0303 62.8195V81.3794H8.98323C5.57192 81.3794 2.80654 78.6141 2.80654 75.2028V59.9957H8.46143V66.3328C6.2633 66.8366 4.62363 68.8045 4.62363 71.1554C4.62363 73.8879 6.83876 76.103 9.57125 76.103C12.3037 76.103 14.5189 73.8879 14.5189 71.1554C14.5189 68.9445 13.0686 67.0722 11.0675 66.4381V59.9957H13.2035C13.9231 59.9957 14.5065 59.4123 14.5065 58.6927C14.5065 57.973 13.9231 57.3896 13.2035 57.3896H2.80654V53.7397H13.3593C14.0789 53.7397 14.6623 53.1563 14.6623 52.4367V44.1377C16.6814 43.5144 18.1485 41.6333 18.1485 39.4095C18.1485 36.677 15.9333 34.4619 13.2008 34.4619C10.4683 34.4619 8.25323 36.677 8.25323 39.4095C8.25323 41.748 9.87562 43.7076 12.0562 44.2241V51.1336H2.80654V28.2429C2.80654 27.8149 2.61487 27.4316 2.31268 27.1742V25.8049C3.06106 26.2347 3.88565 26.446 4.62931 26.4655C4.66611 26.4684 4.70332 26.4698 4.74087 26.4698H75.0289V42.7463C75.0289 42.9323 75.0651 43.11 75.1309 43.2725H63.567C58.1982 43.2725 53.8459 47.6248 53.8459 52.9936C53.8459 58.3625 58.1982 62.7148 63.567 62.7148ZM6.67314 19.2829H5.81148C5.55408 19.5854 5.1706 19.7772 4.74231 19.7772C4.26582 19.7772 3.76263 19.9102 3.41294 20.1808C3.12364 20.4047 2.80655 20.8189 2.80655 21.7323C2.80655 22.4586 3.09078 22.8997 3.44222 23.1869C3.83611 23.5089 4.35132 23.6604 4.74231 23.6604C4.77278 23.6604 4.80302 23.6614 4.83301 23.6633H7.41187C7.06629 22.5116 6.83682 21.3086 6.73769 20.0755C6.70607 19.8123 6.68552 19.549 6.67314 19.2829ZM9.5279 23.6633H25.2513C24.9057 22.5116 24.6762 21.3086 24.577 20.0755C24.5169 19.5743 24.4969 19.0732 24.4969 18.5519C24.4969 12.7985 27.2433 7.66656 31.5132 4.39893L31.5141 4.39828C29.3895 3.35633 27.0044 2.75509 24.4991 2.75509C15.7787 2.75509 8.68216 9.85171 8.68216 18.5519C8.68216 19.0732 8.70223 19.5743 8.76231 20.0755C8.8753 21.3182 9.13749 22.5212 9.5279 23.6633ZM35.3234 4.39828C37.448 3.35633 39.8331 2.75509 42.3384 2.75509C51.0387 2.75509 58.1352 9.85171 58.1352 18.5519C58.1352 19.0732 58.1152 19.5743 58.0551 20.0755C57.9421 21.3182 57.6799 22.5212 57.2896 23.6633H48.3613C48.3649 23.6444 48.3682 23.6253 48.3712 23.606C48.4113 23.2452 48.3312 22.9444 48.1106 22.6639C47.8901 22.3832 47.5894 22.2228 47.2285 22.1826C46.8476 22.1226 46.5671 22.2027 46.3065 22.4033C45.2239 23.2051 44.001 23.5859 42.6379 23.5859C42.2971 23.5859 41.9562 23.5459 41.6355 23.4857C40.9539 23.3454 40.3325 23.0848 39.7511 22.6639C39.4705 22.4834 39.2098 22.2629 38.9693 22.0224C38.3679 21.4409 37.9269 20.7795 37.6663 20.0778C37.4457 19.5165 37.3455 18.9351 37.3455 18.3136C37.3455 16.8703 37.9069 15.6274 38.9693 14.5649C39.1899 14.3645 39.4104 14.184 39.6309 14.0237C40.2122 13.5826 40.8336 13.2819 41.4952 13.1216C41.8761 13.0214 42.257 12.9813 42.6579 12.9813C44.001 12.9813 45.2239 13.3822 46.2864 14.144C46.587 14.4045 46.8878 14.4848 47.2285 14.4446C47.5894 14.3846 47.8901 14.2241 48.1106 13.9435C48.3312 13.6628 48.4113 13.3421 48.3712 12.9612C48.3111 12.5803 48.1507 12.2996 47.87 12.0791C46.8476 11.2973 45.7451 10.7961 44.5624 10.5355V8.25026C44.5624 7.7891 44.2016 7.40821 43.7204 7.40821C43.2593 7.40821 42.8784 7.7891 42.8784 8.25026V10.3351H42.8183C42.1367 10.3351 41.5153 10.4353 40.8938 10.5756V8.25026C40.8938 7.7891 40.533 7.40821 40.0519 7.40821C39.5907 7.40821 39.2098 7.7891 39.2098 8.25026V11.2171C39.1097 11.2672 39.0145 11.3173 38.9194 11.3674L38.9193 11.3675L38.9192 11.3675L38.9191 11.3675L38.919 11.3676L38.9189 11.3676L38.9188 11.3677L38.9187 11.3677L38.9186 11.3678L38.9186 11.3678L38.9185 11.3679L38.9184 11.3679L38.9183 11.368L38.9182 11.368L38.9181 11.368L38.918 11.3681L38.9179 11.3681L38.9178 11.3682L38.9175 11.3683C38.8228 11.4182 38.7281 11.468 38.6285 11.5179C38.1073 11.8386 37.5861 12.2195 37.105 12.6805C35.5213 14.2442 34.7395 16.0684 34.7395 18.2736C34.7395 18.8951 34.7997 19.4965 34.9399 20.0778C35.2411 21.4144 35.9136 22.6096 36.9074 23.6633H27.3673C26.9769 22.5212 26.7148 21.3182 26.6018 20.0755C26.5416 19.5743 26.5216 19.0732 26.5216 18.5519C26.5216 13.1594 29.268 8.36827 33.4177 5.52155L33.4188 5.52078L33.4199 5.52155C34.0213 5.10064 34.6628 4.71975 35.3242 4.39893L35.3234 4.39828ZM69.1752 23.6633H59.4055C59.7511 22.5116 59.9806 21.3086 60.0798 20.0755C60.0918 19.9761 60.1021 19.8768 60.111 19.7772H69.1752V23.6633ZM63.567 46.079C59.7482 46.079 56.6524 49.1748 56.6524 52.9936C56.6524 56.8125 59.7482 59.9082 63.567 59.9082H78.555V46.079H63.567ZM66.6728 49.7382C66.6728 48.9632 66.0445 48.335 65.2695 48.335C64.4945 48.335 63.8662 48.9632 63.8662 49.7382V56.5765C63.8662 57.3515 64.4945 57.9797 65.2695 57.9797C66.0445 57.9797 66.6728 57.3515 66.6728 56.5765V49.7382ZM13.2008 37.068C11.9076 37.068 10.8593 38.1163 10.8593 39.4095C10.8593 40.7027 11.9076 41.7511 13.2008 41.7511C14.494 41.7511 15.5424 40.7027 15.5424 39.4095C15.5424 38.1163 14.494 37.068 13.2008 37.068ZM37.4893 38.267C37.4893 37.4939 38.116 36.8672 38.889 36.8672C39.6621 36.8672 40.2888 37.4939 40.2888 38.267C40.2888 39.04 39.6621 39.6667 38.889 39.6667C38.116 39.6667 37.4893 39.04 37.4893 38.267ZM38.889 34.6621C36.8981 34.6621 35.2842 36.2761 35.2842 38.267C35.2842 40.2579 36.8981 41.8718 38.889 41.8718C40.88 41.8718 42.4939 40.2579 42.4939 38.267C42.4939 36.2761 40.88 34.6621 38.889 34.6621ZM45.8803 72.2596C45.1072 72.2596 44.4805 72.8863 44.4805 73.6594C44.4805 74.4324 45.1072 75.0591 45.8803 75.0591C46.6533 75.0591 47.28 74.4324 47.28 73.6594C47.28 72.8863 46.6533 72.2596 45.8803 72.2596ZM42.2754 73.6594C42.2754 71.6684 43.8893 70.0545 45.8803 70.0545C47.8712 70.0545 49.4851 71.6684 49.4851 73.6594C49.4851 75.6503 47.8712 77.2642 45.8803 77.2642C43.8893 77.2642 42.2754 75.6503 42.2754 73.6594ZM7.22971 71.1554C7.22971 69.8622 8.27805 68.8139 9.57125 68.8139C10.8644 68.8139 11.9128 69.8622 11.9128 71.1554C11.9128 72.4486 10.8644 73.497 9.57125 73.497C8.27805 73.497 7.22971 72.4486 7.22971 71.1554ZM28.5457 47.0795C27.2525 47.0795 26.2041 48.1279 26.2041 49.4211C26.2041 50.7142 27.2525 51.7626 28.5457 51.7626C29.8389 51.7626 30.8872 50.7142 30.8872 49.4211C30.8872 48.1279 29.8389 47.0795 28.5457 47.0795ZM22.0275 50.7252H23.7717C24.344 52.8249 26.2646 54.3687 28.5457 54.3687C31.2782 54.3687 33.4933 52.1535 33.4933 49.4211C33.4933 46.6886 31.2782 44.4734 28.5457 44.4734C26.2637 44.4734 24.3426 46.0183 23.7711 48.1191H20.7244C20.0048 48.1191 19.4214 48.7025 19.4214 49.4222V58.6955C19.4214 59.4151 20.0048 59.9985 20.7244 59.9985C21.4441 59.9985 22.0275 59.4151 22.0275 58.6955V50.7252ZM30.2742 67.2199C30.2742 65.9267 31.3226 64.8783 32.6158 64.8783C33.909 64.8783 34.9573 65.9267 34.9573 67.2199C34.9573 68.5131 33.909 69.5614 32.6158 69.5614C31.3226 69.5614 30.2742 68.5131 30.2742 67.2199ZM32.6158 62.2723C29.8833 62.2723 27.6682 64.4874 27.6682 67.2199C27.6682 69.9524 29.8833 72.1675 32.6158 72.1675C35.3483 72.1675 37.5634 69.9524 37.5634 67.2199C37.5634 64.4874 35.3483 62.2723 32.6158 62.2723ZM23.6632 31.7311C24.0546 31.3396 24.6893 31.3396 25.0807 31.7311L26.4065 33.0568L27.7322 31.7311C28.1236 31.3396 28.7583 31.3396 29.1497 31.7311C29.5411 32.1225 29.5411 32.7572 29.1497 33.1486L27.824 34.4743L29.1497 35.8001C29.5411 36.1915 29.5411 36.8261 29.1497 37.2176C28.7583 37.609 28.1236 37.609 27.7322 37.2176L26.4065 35.8918L25.0807 37.2176C24.6893 37.609 24.0546 37.609 23.6632 37.2176C23.2718 36.8261 23.2718 36.1915 23.6632 35.8001L24.9889 34.4743L23.6632 33.1486C23.2718 32.7572 23.2718 32.1225 23.6632 31.7311ZM39.7887 54.4869C40.1801 54.0955 40.8148 54.0955 41.2062 54.4869L42.5319 55.8127L43.8577 54.4869C44.2491 54.0955 44.8838 54.0955 45.2752 54.4869C45.6666 54.8784 45.6666 55.513 45.2752 55.9045L43.9495 57.2302L45.2752 58.5559C45.6666 58.9473 45.6666 59.582 45.2752 59.9734C44.8838 60.3649 44.2491 60.3649 43.8577 59.9734L42.5319 58.6477L41.2062 59.9734C40.8148 60.3649 40.1801 60.3649 39.7887 59.9734C39.3973 59.582 39.3973 58.9473 39.7887 58.5559L41.1144 57.2302L39.7887 55.9045C39.3973 55.513 39.3973 54.8784 39.7887 54.4869Z"
                              fill="#2692AA"
                            />
                          </svg>
                        </div>
                      </div>
                      <div className="sec-22">
                        <div className="service-head">
                          <h3>Proprietary software architecture</h3>
                        </div>
                        <div className="main-para-div">
                          <p>
                            Frameworks allow rapid development while maintaining
                            quality.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div className="row second-row col-xl-11 col-lg-11 col-md-12 offset-xl-2 offset-lg-2 offset-md-0 offset-sm-0">
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                      <div className="overall-sec-11">
                        <div className="sec-11">
                          <div
                            className="service-img ylow-bx"
                            title="Delightful user interface"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="130"
                              height="130"
                              viewBox="0 0 130 130"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.2 26.6504C19.277 26.6504 20.15 27.5234 20.15 28.6004V104.65H120.9C121.977 104.65 122.85 105.523 122.85 106.6C122.85 107.677 121.977 108.55 120.9 108.55H18.2C17.123 108.55 16.25 107.677 16.25 106.6V28.6004C16.25 27.5234 17.123 26.6504 18.2 26.6504Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M32.5001 48.3678V73.8325H44.2001V48.3678H32.5001ZM31.2001 44.4678C29.7642 44.4678 28.6001 45.6318 28.6001 47.0678V75.1325C28.6001 76.5684 29.7642 77.7325 31.2001 77.7325H45.5001C46.936 77.7325 48.1001 76.5684 48.1001 75.1325V47.0678C48.1001 45.6318 46.936 44.4678 45.5001 44.4678H31.2001Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M38.3499 46.6855C37.2729 46.6855 36.3999 45.8125 36.3999 44.7355L36.3999 36.4385C36.3999 35.3615 37.2729 34.4885 38.3499 34.4885C39.4269 34.4885 40.2999 35.3615 40.2999 36.4385L40.2999 44.7355C40.2999 45.8125 39.4269 46.6855 38.3499 46.6855Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M38.3499 87.7119C37.2729 87.7119 36.3999 86.8389 36.3999 85.7619L36.3999 77.4649C36.3999 76.3879 37.2729 75.5149 38.3499 75.5149C39.4269 75.5149 40.2999 76.3879 40.2999 77.4649L40.2999 85.7619C40.2999 86.8389 39.4269 87.7119 38.3499 87.7119Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M61.1002 59.4557V84.9204H72.8002V59.4557H61.1002ZM59.8002 55.5557C58.3643 55.5557 57.2002 56.7197 57.2002 58.1557V86.2204C57.2002 87.6563 58.3643 88.8204 59.8002 88.8204H74.1002C75.5361 88.8204 76.7002 87.6563 76.7002 86.2204V58.1557C76.7002 56.7197 75.5361 55.5557 74.1002 55.5557H59.8002Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M66.95 57.7734C65.873 57.7734 65 56.9004 65 55.8234L65 47.5264C65 46.4494 65.873 45.5764 66.95 45.5764C68.027 45.5764 68.9 46.4494 68.9 47.5264L68.9 55.8234C68.9 56.9004 68.027 57.7734 66.95 57.7734Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M66.95 98.7998C65.873 98.7998 65 97.9268 65 96.8498L65 88.5527C65 87.4758 65.873 86.6027 66.95 86.6027C68.027 86.6027 68.9 87.4758 68.9 88.5527L68.9 96.8498C68.9 97.9268 68.027 98.7998 66.95 98.7998Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M89.6998 37.2799V62.7446H101.4V37.2799H89.6998ZM88.3998 33.3799C86.9639 33.3799 85.7998 34.5439 85.7998 35.9799V64.0446C85.7998 65.4805 86.9639 66.6446 88.3998 66.6446H102.7C104.136 66.6446 105.3 65.4805 105.3 64.0446V35.9799C105.3 34.5439 104.136 33.3799 102.7 33.3799H88.3998Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M95.5496 35.5977C94.4727 35.5977 93.5996 34.7246 93.5996 33.6477L93.5996 25.3506C93.5996 24.2736 94.4727 23.4006 95.5496 23.4006C96.6266 23.4006 97.4996 24.2736 97.4996 25.3506L97.4996 33.6477C97.4996 34.7246 96.6266 35.5977 95.5496 35.5977Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M95.5496 76.624C94.4727 76.624 93.5996 75.751 93.5996 74.674L93.5996 66.377C93.5996 65.3 94.4727 64.427 95.5496 64.427C96.6266 64.427 97.4996 65.3 97.4996 66.377L97.4996 74.674C97.4996 75.751 96.6266 76.624 95.5496 76.624Z"
                                fill="#2692AA"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M41 50.5C41.8284 50.5 42.5 51.1716 42.5 52V70C42.5 70.8284 41.8284 71.5 41 71.5H36C35.1716 71.5 34.5 70.8284 34.5 70C34.5 69.1716 35.1716 68.5 36 68.5H39.5V52C39.5 51.1716 40.1716 50.5 41 50.5Z"
                                fill="#FFCC4A"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M69 61.5C69.8284 61.5 70.5 62.1716 70.5 63V81C70.5 81.8284 69.8284 82.5 69 82.5H65C64.1716 82.5 63.5 81.8284 63.5 81C63.5 80.1716 64.1716 79.5 65 79.5H67.5V63C67.5 62.1716 68.1716 61.5 69 61.5Z"
                                fill="#FFCC4A"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M98 39.5C98.8284 39.5 99.5 40.1716 99.5 41V59C99.5 59.8284 98.8284 60.5 98 60.5H93C92.1716 60.5 91.5 59.8284 91.5 59C91.5 58.1716 92.1716 57.5 93 57.5H96.5V41C96.5 40.1716 97.1716 39.5 98 39.5Z"
                                fill="#FFCC4A"
                              />
                            </svg>
                          </div>
                        </div>

                        <div className="sec-22">
                          <div className="service-head">
                            <h3>Delightful user interface</h3>
                          </div>
                          <div className="main-para-div">
                            <p>
                              Attention to detail and visual aesthetics help
                              gain acceptance more readily.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                      <div className="overall-sec-11">
                        <div className="sec-11">
                          <div
                            className="service-img ylow-bx"
                            title="Agile software development methodology"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="130"
                              height="130"
                              viewBox="0 0 130 130"
                              fill="none"
                            >
                              <rect width="130" height="130" fill="white" />
                              <circle cx="47" cy="29" r="4" fill="#FFCC4A" />
                              <circle cx="79" cy="24" r="4" fill="#FFCC4A" />
                              <circle cx="101" cy="48" r="4" fill="#FFCC4A" />
                              <circle cx="108" cy="66" r="4" fill="#FFCC4A" />
                              <circle
                                cx="101.5"
                                cy="86.5"
                                r="4.5"
                                fill="#FFCC4A"
                              />
                              <circle
                                cx="67.5"
                                cy="103.5"
                                r="4.5"
                                fill="#FFCC4A"
                              />
                              <circle
                                cx="43.5"
                                cy="103.5"
                                r="4.5"
                                fill="#FFCC4A"
                              />
                              <circle
                                cx="21.5"
                                cy="68.5"
                                r="4.5"
                                fill="#FFCC4A"
                              />
                              <circle
                                cx="25.5"
                                cy="46.5"
                                r="4.5"
                                fill="#FFCC4A"
                              />
                              <path
                                d="M108.134 60.7151C105.384 60.7151 103.087 62.652 102.514 65.2312H86.3666C87.6396 60.738 88.521 55.5673 88.8262 49.6277H95.7322C96.305 52.2069 98.6024 54.1438 101.352 54.1438C104.531 54.1438 107.116 51.5587 107.116 48.3795C107.116 45.2003 104.531 42.6152 101.352 42.6152C98.6024 42.6152 96.305 44.5521 95.7322 47.1313H88.9329C88.9603 45.9277 88.9676 44.6984 88.9471 43.4342C88.9405 43.0928 88.7809 42.7714 88.5126 42.5607C88.2421 42.3457 87.8874 42.2681 87.5615 42.3457C87.459 42.3699 78.7517 44.2503 68.5514 41.4119V25.6296H73.8071C73.9698 26.2044 74.198 26.7632 74.5396 27.2747C75.3954 28.5561 76.6968 29.4252 78.2066 29.7245C78.5835 29.7999 78.9604 29.8354 79.3306 29.8354C82.0243 29.8354 84.4387 27.9353 84.984 25.1973C85.6048 22.0779 83.5718 19.0384 80.4569 18.4198C78.9537 18.1205 77.4084 18.4243 76.1292 19.28C74.8477 20.1336 73.9787 21.4372 73.6794 22.947C73.667 23.0091 73.6712 23.0712 73.6608 23.1332H67.3032C66.6137 23.1332 66.055 23.6919 66.055 24.3814V40.6253C64.9247 40.2287 63.7872 39.7915 62.6442 39.2618C62.3427 39.1243 61.9924 39.1243 61.6909 39.2618C60.885 39.6348 60.0805 39.97 59.2797 40.2757V29.6048C59.2797 28.9153 58.721 28.3566 58.0315 28.3566H52.8873C52.3142 25.779 50.0171 23.8427 47.2678 23.8427C44.0908 23.8427 41.5057 26.4278 41.5057 29.6048C41.5057 32.784 44.0908 35.3691 47.2678 35.3691C50.0173 35.3691 52.3147 33.4322 52.8876 30.853H56.7833V41.1284C46.1541 44.384 36.8794 42.3688 36.7736 42.3457C36.4477 42.2703 36.0929 42.3479 35.8225 42.5607C35.5542 42.7714 35.3946 43.0928 35.3879 43.4342C35.3117 48.1324 35.5923 52.3846 36.1238 56.2722H27.126V52.6979C29.7052 52.125 31.6421 49.8276 31.6421 47.0781C31.6421 43.9011 29.057 41.316 25.8778 41.316C22.6986 41.316 20.1135 43.9011 20.1135 47.0781C20.1135 49.8276 22.0504 52.125 24.6296 52.6979V57.5203C24.6296 58.2098 25.1883 58.7685 25.8778 58.7685H36.5073C37.0585 61.95 37.7899 64.8544 38.6607 67.5037H26.9815C26.4086 64.9244 24.1112 62.9876 21.3617 62.9876C18.1847 62.9876 15.5996 65.5726 15.5996 68.7519C15.5996 71.9289 18.1847 74.5139 21.3617 74.5139C24.111 74.5139 26.4081 72.5776 26.9812 70.0001H39.5472C43.4919 80.2788 49.4994 86.3439 54.2936 89.7612V102.186H49.0355C48.3508 99.7669 46.1476 97.9799 43.5121 97.9799C40.3329 97.9799 37.7478 100.565 37.7478 103.744C37.7478 106.923 40.3329 109.509 43.5121 109.509C46.3702 109.509 48.7303 107.414 49.1816 104.682H55.5418C56.2313 104.682 56.79 104.123 56.79 103.434V91.3844C59.7253 93.1203 61.7872 93.7405 61.8616 93.761C61.9613 93.7898 62.0655 93.8031 62.1675 93.8031C62.2695 93.8031 62.3737 93.7898 62.4735 93.761C62.5346 93.7441 63.9347 93.3239 66.055 92.2164V97.9759C63.4757 98.5487 61.5389 100.846 61.5389 103.596C61.5389 106.775 64.1239 109.36 67.3032 109.36C70.4802 109.36 73.0652 106.775 73.0652 103.596C73.0652 100.846 71.1289 98.5493 68.5514 97.9762V90.764C72.5255 88.2247 77.7232 83.7605 81.8839 76.2676H100.104V80.629C97.5245 81.2018 95.5876 83.4992 95.5876 86.2487C95.5876 89.4257 98.1727 92.0108 101.352 92.0108C104.531 92.0108 107.116 89.4257 107.116 86.2487C107.116 83.4992 105.179 81.2018 102.6 80.629V75.0194C102.6 74.3299 102.041 73.7712 101.352 73.7712H83.1813C84.0654 71.9282 84.8732 69.905 85.5993 67.7276H102.514C103.087 70.3068 105.384 72.2437 108.134 72.2437C111.311 72.2437 113.896 69.6586 113.896 66.4794C113.896 63.3002 111.311 60.7151 108.134 60.7151ZM101.352 45.1116C103.154 45.1116 104.62 46.577 104.62 48.3795C104.62 50.1819 103.154 51.6474 101.352 51.6474C99.5495 51.6474 98.084 50.1819 98.084 48.3795C98.084 46.577 99.5495 45.1116 101.352 45.1116ZM76.127 23.4348C76.2977 22.579 76.7899 21.8407 77.5171 21.3552C78.0602 20.9916 78.6832 20.8031 79.3239 20.8031C79.539 20.8031 79.7541 20.8253 79.9691 20.8674C80.8249 21.0381 81.5631 21.5303 82.0465 22.2575C82.532 22.9825 82.7049 23.8538 82.5364 24.7096C82.1839 26.4765 80.448 27.6272 78.6943 27.2769C77.8385 27.1062 77.1003 26.6118 76.6147 25.8868C76.1292 25.1618 75.9563 24.2905 76.127 23.4348ZM47.2678 32.8727C45.4676 32.8727 44.0021 31.4072 44.0021 29.6048C44.0021 27.8045 45.4676 26.3391 47.2678 26.3391C49.0702 26.3391 50.5357 27.8045 50.5357 29.6048C50.5357 31.4072 49.0702 32.8727 47.2678 32.8727ZM22.6099 47.0781C22.6099 45.2779 24.0753 43.8124 25.8778 43.8124C27.6803 43.8124 29.1457 45.2779 29.1457 47.0781C29.1457 48.8805 27.6803 50.346 25.8778 50.346C24.0753 50.346 22.6099 48.8805 22.6099 47.0781ZM21.3617 72.0176C19.5615 72.0176 18.096 70.5521 18.096 68.7519C18.096 66.9494 19.5615 65.4839 21.3617 65.4839C23.1641 65.4839 24.6296 66.9494 24.6296 68.7519C24.6296 70.5521 23.1641 72.0176 21.3617 72.0176ZM43.5121 107.012C41.7097 107.012 40.2442 105.547 40.2442 103.744C40.2442 101.942 41.7097 100.476 43.5121 100.476C45.3146 100.476 46.78 101.942 46.78 103.744C46.78 105.547 45.3146 107.012 43.5121 107.012ZM70.5689 103.596C70.5689 105.398 69.1034 106.864 67.3032 106.864C65.5007 106.864 64.0352 105.398 64.0352 103.596C64.0352 101.793 65.5007 100.328 67.3032 100.328C69.1034 100.328 70.5689 101.793 70.5689 103.596ZM104.62 86.2487C104.62 88.049 103.154 89.5144 101.352 89.5144C99.5495 89.5144 98.084 88.049 98.084 86.2487C98.084 84.4463 99.5495 82.9808 101.352 82.9808C103.154 82.9808 104.62 84.4463 104.62 86.2487ZM74.5054 82.8776C69.078 88.8348 63.5177 91.0119 62.1675 91.4753C60.8174 91.0119 55.257 88.8348 49.8297 82.8776C44.2095 76.712 37.6027 65.1346 37.6449 44.811C41.2786 45.3764 51.4748 46.3275 62.1675 41.5409C72.8647 46.3253 83.0631 45.3742 86.6902 44.811C86.7323 65.1346 80.1255 76.712 74.5054 82.8776ZM108.134 69.7473C106.331 69.7473 104.866 68.2818 104.866 66.4794C104.866 64.6769 106.331 63.2115 108.134 63.2115C109.934 63.2115 111.4 64.6769 111.4 66.4794C111.4 68.2818 109.934 69.7473 108.134 69.7473Z"
                                fill="#2692AA"
                              />
                              <path
                                d="M81.8663 48.5283C81.5958 48.3155 81.241 48.2356 80.9151 48.3132C80.822 48.3332 71.8098 50.2953 62.6445 46.0474C62.343 45.91 61.9927 45.91 61.6912 46.0474C52.5215 50.2953 43.5115 48.3332 43.4206 48.3132C43.0969 48.2379 42.74 48.3155 42.4695 48.5283C42.2012 48.7389 42.0416 49.0604 42.0349 49.4018C41.7689 65.7902 47.1142 75.1106 51.6436 80.0435C56.6186 85.4575 61.6513 86.9119 61.8619 86.9717C61.9617 87.0006 62.0659 87.0139 62.1679 87.0139C62.2698 87.0139 62.374 87.0006 62.4738 86.9717C62.6844 86.9119 67.7171 85.4575 72.6921 80.0435C77.2216 75.1106 82.5668 65.7902 82.3008 49.4018C82.2941 49.0604 82.1345 48.7389 81.8663 48.5283ZM62.1745 84.686C59.8156 83.8479 44.3695 77.3343 44.2963 50.7675C47.2561 51.1865 54.5324 51.6987 62.1679 48.3243C69.8056 51.7031 77.0819 51.1865 80.0394 50.7675C79.9796 77.5427 64.6643 83.8413 62.1745 84.686Z"
                                fill="#2692AA"
                              />
                              <path
                                d="M66.8918 68.6819C66.5428 68.6348 66.267 68.7081 66.0261 68.9037C65.0031 69.6489 63.8459 70.0208 62.5664 70.0208C61.2625 70.0208 60.0913 69.5233 59.0894 68.5441C58.0822 67.5579 57.5726 66.3752 57.5726 65.0277C57.5726 63.6793 58.0874 62.4914 59.1051 61.4974C60.1227 60.5051 61.2922 60.0025 62.5821 60.0025C63.8476 60.0025 64.9996 60.3733 66.0068 61.1055C66.2932 61.3395 66.5688 61.4145 66.9075 61.3743C67.2478 61.3264 67.462 61.0989 67.6768 60.8301C67.8844 60.5657 68.0194 60.3376 67.9722 59.9833C67.9234 59.6262 67.7715 59.353 67.508 59.1506C66.5417 58.4138 65.4934 57.9426 64.3883 57.6978V55.534C64.3883 55.0928 64.0313 55.084 63.5901 55.084C63.149 55.084 62.7919 55.0928 62.7919 55.534V57.5004C62.7694 57.5002 62.7479 57.4949 62.7252 57.4949C62.0979 57.501 61.5029 57.5967 60.9244 57.7361V55.534C60.9244 55.0928 60.5675 55.084 60.1263 55.084C59.6852 55.084 59.3281 55.0928 59.3281 55.534V58.3323C58.6221 58.6886 57.951 59.1307 57.3439 59.7206C55.8323 61.1946 55.0957 62.9201 55.0957 64.9955C55.0957 67.0438 55.8532 68.8251 57.3456 70.2879C57.9516 70.8818 58.6223 71.325 59.3281 71.6804V74.3871C59.3281 74.8283 59.6852 74.842 60.1263 74.842C60.5675 74.842 60.9244 74.8283 60.9244 74.3871V72.2707C61.5025 72.4065 62.0974 72.4976 62.7252 72.4976C62.7478 72.4976 62.7694 72.4925 62.7919 72.4923V74.3871C62.7919 74.8283 63.149 74.842 63.5901 74.842C64.0313 74.842 64.3883 74.8283 64.3883 74.3871V72.2962C65.4789 72.0579 66.5299 71.6044 67.5201 70.897C67.7628 70.6788 67.9234 70.3874 67.974 70.0364C68.0194 69.7013 67.7784 69.4614 67.5673 69.1908C67.3542 68.9256 67.2445 68.7308 66.8918 68.6819Z"
                                fill="#2692AA"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="sec-22">
                          <div className="service-head">
                            <h3>Agile software development methodology</h3>
                          </div>
                          <div className="main-para-div">
                            <p>
                              Rapid and continuous delivery of useful software.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="beige-bg">
            <Testimonials />
          </div>

          <div className="blog-card-title-container">
          <div className="custom-section">
              <h3 class="main-head-1">
                    <span class="secondary-span">Latest </span>
                     <span class="primary-span">Blogs</span>
              </h3>
              </div>
          </div>

          <div className="blog-card-container">
        <Slider {...blogSettings}>
          {this.state.blogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              <h2 className="blog-span">{blog.title.rendered}</h2>
              <img src={blog.yoast_head_json.og_image[0].url} alt="Manifest" title="Manifest"></img>
              <div className="blog-sub-title-span" dangerouslySetInnerHTML={{ __html: blog.excerpt.rendered.substring(0, 400) }} />
          <div class="blog-read-more-link">
             <a href={blog.link}>Read More</a>
                </div>
            </div>
          ))}
        </Slider>
      </div>

          <div className="section-6 blue-bg company-info ix-awards">
            <div className="custom-container">
              <div className="custom-section">
              <h3 class="main-head-1">
                    <span class="secondary-span">Featured</span>
                     <span class="primary-span">Awards</span>
              </h3>
              </div>
            </div>
            <div>
            <ul className="award-card-ul">
              <Slider {...awardSettings}>
                                <li>
                                    <a href="https://blog.ionixxtech.com/ionixx-technologies-ranking-in-goodfirms-list-of-top-private-blockchain-technologies/" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                <img src="assets/img/awards-new/award-1.svg" alt="Top Blockchain Development Company" title="Top Blockchain Development Company"></img>
                                            </div>
                                        </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Private Blockchain Development Company</h4>
                                            <p className="award-year">2020</p>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://themanifest.com/blockchain/companies" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                <img src="assets/img/awards-new/award-7.png" alt="Manifest" title="Manifest"></img>
                                            </div>
                                        </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top 100 Blockchain Development Companies</h4>
                                            <p className="award-year">2020</p>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.goodfirms.co/directory/languages/top-software-development-companies?page=22" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                    <img src="assets/img/awards-new/award-2.svg" alt="Good Firms" title="Good Firms"></img>
                                                </div>
                                            </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Software Development Company</h4>
                                            <p className="award-year">2020</p>
                                        </div>
                                        </a>
                                    </li>
                                <li>
                                <a href="https://www.goodfirms.co/directory/services/list-blockchain-technology-companies?page=5" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                    <img src="assets/img/awards-new/award-1.svg" alt="Top Blockchain Development Company" title="Top Blockchain Development Company"></img>
                                                </div>
                                            </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Blockchain Development Company</h4>
                                            <p className="award-year">2019</p>
                                        </div>
                                        </a>
                                </li>
                                <li>
                                <a href="https://blog.ionixxtech.com/ionixx-technologies-named-a-top-custom-software-developer-in-india-by-clutch-co/" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                    <img src="assets/img/awards-new/award-4.png" alt="Clutch" title="Clutch"></img>
                                                </div>
                                            </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Software Developers</h4>
                                            <p className="award-year">2018</p>
                                        </div>
                                        </a>
                                </li>
                                <li>
                                <a href="https://blog.ionixxtech.com/ionixx-technologies-featured-as-industry-leader-in-blockchain-development/" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                    <img src="assets/img/awards-new/award-3.png" alt="Clutch" title="Clutch"></img>
                                                </div>
                                            </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Developers</h4>
                                            <p className="award-year">2019</p>
                                        </div>
                                        </a>
                                </li>
                                <li>
                                <a href="https://blog.ionixxtech.com/ionixx-technologies-named-a-top-custom-software-developer-in-india-by-clutch-co/" target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                            <img src="assets/img/awards-new/award-5.png" alt="Award" title="Award"></img>
                                                </div>
                                            </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Software Developers</h4>
                                            <p className="award-year">2018</p>
                                        </div>
                                        </a>
                                </li>
                                <li>
                                    <a href="https://clutch.co/press-releases/honors-top-1000-service-providers-2020-exclusive-1000-list " target="_blank">
                                        <div className="award-card ylow-bx">
                                            <div className="award-card-img-hold">
                                                        <img src="assets/img/awards-new/award-8.png" alt="Award" title="Award"></img>
                                            </div>
                                        </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top 1000 Companies</h4>
                                            <p className="award-year">2020</p>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://clutch.co/press-releases/recognizes-top-b2b-providers-indian-emerging-tech-market-2021" target="_blank">
                                        <div className="award-card ylow-bx">
                                        <div className="award-card-img-hold">
                                                        <img src="assets/img/awards-new/emerge-2021.png" alt="Award" title="Award"></img>
                                            </div>
                                        </div>
                                        <div className="award-info">
                                            <h4 className="award-name">Top Emerging Technologies</h4>
                                            <p className="award-year">2021</p>
                                        </div>
                                    </a>
                                </li>
                                {/* <li className="empty">
                                    <div className="award-card ylow-bx">
                                        <div className="award-card-img-hold">
                                            <img src="assets/img/awards-new/award-3.png" alt="Clutch" title="Clutch"></img>
                                        </div>
                                    </div>
                                    <div className="award-info">
                                        <h4 className="award-name">Top Developers</h4>
                                        <p className="award-year">2019</p>
                                    </div>
                                </li> */}
              </Slider>
              </ul>
            </div>
          </div>

          {/* <div className="section-6 beige-bg company-info ix-media">
            <div className="custom-container">
              <div className="custom-section">
                <div className="main-head-div custom-main-head-div">
                  <h2 className="main-head-1">
                    <span className="secondary-span">Ionixx in</span>
                    <span className="primary-span">Media</span>
                  </h2>
                </div>
              </div>
            </div>
            <div>
              <Slider {...settings}>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div className="service-img ylow-sqr-bx" title="Forbes">
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img1.png"
                            alt="Forbes"
                            title="Forbes"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Yourstory"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img2.png"
                            alt="Yourstory"
                            title="Yourstory"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div className="service-img ylow-sqr-bx" title="Blokt">
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img3.png"
                            alt="Blokt"
                            title="Blokt"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="India Currents"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img4.png"
                            alt="India Currents"
                            title="India Currents"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Crypto Ninjas"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img5.png"
                            alt="Crypto Ninjas"
                            title="Crypto Ninjas"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Entrepreneur"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img6.png"
                            alt="Entrepreneur"
                            title="Entrepreneur"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div className="service-img ylow-sqr-bx" title="Inc42">
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img7.png"
                            alt="Inc42"
                            title="Inc42"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Yahoo Finance"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img8.png"
                            alt="Yahoo Finance"
                            title="Yahoo Finance"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Insightssuccess"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img9.png"
                            alt="Insightssuccess"
                            title="Insightssuccess"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Crypto Women"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img10.png"
                            alt="Crypto Women"
                            title="Crypto Women"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="The Hindu"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img11.png"
                            alt="The Hindu"
                            title="The Hindu"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Firstpost"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img12.png"
                            alt="Firstpost"
                            title="Firstpost"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="BusinessWorld"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img13.png"
                            alt="BusinessWorld"
                            title="BusinessWorld"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="criteria-col">
                  <Link to={ResourceRoute.PRESS} target="_blank">
                    <div className="criteria-col-common">
                      <div
                        className="service-img ylow-sqr-bx"
                        title="Smart Market News"
                      >
                        <div className="criteria-image-hold">
                          <img
                            src="/assets/img/media-img/media-img14.png"
                            alt="Smart Market News"
                            title="Smart Market News"
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </Slider>
            </div>
          </div> */}
          <div className="section-5 blue-bg">
            <div className="custom-container">
              <div className="custom-section connect-with-custom-section">
                <div className="main-head-div">
                  <h4 className="main-head-1">
                    <span className="secondary-span">Let's Team up to</span>
                    <span className="primary-span">Build Your Product</span>
                  </h4>
                </div>
                <div className="main-para-div">
                <Link to={ROUTES.CONTACTUS} className="btn btn-primary connect-btn">Talk to Us</Link>
                </div>
              </div>
            </div>
          </div>
          <ContactUS
            show={this.state.showContactUS}
            handleClose={() => this.setState({ showContactUS: false })}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return state.commonReducer;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(contactAction, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NewHomeDesign);
